import {
  Component,
  EventEmitter,
  input,
  Input,
  InputSignal,
  Output,
  Signal
} from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlertComponent } from '../../alert/alert.component';
import { CommonModule } from '@angular/common';
import { ExposedMapComponent, ExposedMapDictionary } from '../exposed-map.component';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-exposed-map-control',
  standalone: true,
  imports: [
    AlertComponent,
    CommonModule,
    ExposedMapComponent,
    ReactiveFormsModule
  ],
  templateUrl: './exposed-map-control.component.html'
})
export class ExposedMapControlComponent {

  @Input()
  public alertMessage: string | null = 'Proszę wskazać na mapie przybliżoną lokalizację. Plik z planem sytuacyjnym/mapą będzie możliwy do załączenia w ostatnim kroku. Proszę przygotować stosowny plik.';

  @Input()
  public control: FormControl | undefined;

  @Input()
  public showDrawTerrain = false;

  public serviceId: InputSignal<string | null> = input<string | null>(null);

  @Output()
  public dictionary: EventEmitter<ExposedMapDictionary> = new EventEmitter();

  public dictEvent: Signal<ExposedMapDictionary | undefined> = toSignal(this.dictionary.asObservable());

  public get isRequired(): boolean {
    return !!this.control?.hasValidator(Validators.required);
  }
}
